export default __webpack_public_path__ + "static/media/632.513f551f.png";